import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_cart_products,
  delete_card_product,
  messageClear,
  quantity_inc,
  quantity_dec,
} from "../store/reducers/cardReducer";
import { Button } from "../components/ui/button";
import { Minus, Package, Plus, ScrollText, Trash, MapPin } from "lucide-react";
import { Input } from "../components/ui/input";
import axios from "../api/api";
import { formatCurrency } from "../utils/currencyUtils";
import { useCurrency } from "../hooks/useCurrency"

const Card = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const { currencyCode, exchangeLoaded } = useCurrency()
  const [shippingCountry, setShippingCountry] = useState("");
  const {
    card_products,
    successMessage,
    price,
    buy_product_item,
    outofstock_products,
  } = useSelector((state) => state.card);

  const redirect = () => {
    navigate("/shipping", {
      state: {
        products: card_products,
        price: price,
        items: buy_product_item,
      },
    });
  };
console.log(card_products)

  // Fetch user details (including shipping country) when the component mounts
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const { data } = await axios.get("/account/get-details", {
          withCredentials: true,
        });
        if (data.shippingDetails) {
          setShippingCountry(data.shippingDetails.country);
        }
      } catch (error) {
        // Handle error silently
      }
    };

    if (userInfo && userInfo.id) {
      fetchUserDetails();
      dispatch(get_cart_products(userInfo.id));
    }
  }, [userInfo, dispatch]);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
      if (userInfo && userInfo.id) {
        dispatch(get_cart_products(userInfo.id));
      }
    }
  }, [successMessage, userInfo, dispatch]);

  const inc = (quantity, stock, card_id) => {
    const temp = quantity + 1;
    if (stock && temp <= stock) {
      dispatch(quantity_inc(card_id));
    }
  };

  const dec = (quantity, card_id) => {
    const temp = quantity - 1;
    if (temp > 0) {
      dispatch(quantity_dec(card_id));
    }
  };

  // Function to check if a product ships to the user's country
  const shipsToUserCountry = (product) => {
    if (!shippingCountry) return false; // If no country is set, return false
    const shippingPrices = product.productInfo.shippingPrices || {};
    return Object.keys(shippingPrices).includes(shippingCountry); // Check if the user's country is in the shipping locations
  };

  return (
    <div>
      <Headers />
      <section
        className="h-[220px] bg-cover bg-no-repeat relative bg-left"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_URL}/images/banner/cartnew.jpg)`,
        }}
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#0000008a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Omah Global</h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to="/">Home</Link>
                <span className="pt-2">
                  <MdOutlineKeyboardArrowRight />
                </span>
                <span>Cart</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90] mx-auto py-16">
          {card_products.length > 0 || outofstock_products.length > 0 ? (
            <div className="flex flex-wrap">
              <div className="w-[67%] md-lg:w-full">
                <div className="pr-3 md-lg:pr-0">
                  <div className="flex flex-col gap-3">
                    {card_products.map((p, shopIndex) => (
                      <div
                        key={shopIndex}
                        className="flex bg-white border border-gray-100 shadow-sm p-4 flex-col gap-5"
                      >
                        <div className="flex justify-start items-center">
                          <h2 className="text-md text-gray-900 flex items-center">
                            {p.shopName} <Package size={18} className="ml-2" />
                          </h2>
                        </div>
                        {p.products.map((pt, productIndex) => (
                          <div
                            key={productIndex}
                            className="w-full flex flex-wrap"
                          >
                            <div className="flex sm:w-full gap-2 w-7/12">
                              <div className="flex gap-2 justify-start items-center">
                                <img
                                  className="w-[80px] h-[80px] nex_img_cover rounded-md"
                                  src={pt.productInfo.images[0]}
                                  alt="product"
                                />
                                <div className="px-2 text-gray-900">
                                  <h2 className="text-md">
                                    {pt.productInfo.name}
                                  </h2>
                                  <span className="text-sm">
                                    Brand : {pt.productInfo.brand}
                                  </span>
                                  {/* Display shipping info */}
                                  {shippingCountry && (
                                    <div
                                      className={`flex items-center gap-1 mt-1 p-1 rounded ${
                                        shipsToUserCountry(pt)
                                          ? "bg-green-500/20 text-green-500"
                                          : "bg-red-500/20 text-red-500"
                                      }`}
                                    >
                                      <MapPin className="h-4 w-4" />
                                      <span className="text-sm">
                                        {shipsToUserCountry(pt)
                                          ? `Ships to ${shippingCountry}`
                                          : `Does not ship to ${shippingCountry}`}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-between w-5/12 sm:w-full sm:mt-3">
                              <div className="pl-4 sm:pl-0 flex flex-col gap-2">
                                <h2 className="text-lg text-green-500">
                                  {" "}
                                  {formatCurrency(
                                    pt.productInfo.discount
                                      ? pt.productInfo.price -
                                          Math.floor(
                                            (pt.productInfo.price *
                                              pt.productInfo.discount) /
                                              100
                                          )
                                      : pt.productInfo.price,
                                    currencyCode,
                                    exchangeLoaded
                                  )}
                                </h2>
                                <p className="text-gray-400 line-through text-sm">
                                  {formatCurrency(
                                    pt.productInfo.price,
                                    currencyCode,
                                    exchangeLoaded
                                  )}
                                </p>
                                <p className="text-sm">
                                  {pt.productInfo.discount
                                    ? `-${pt.productInfo.discount}%`
                                    : ""}
                                </p>
                              </div>

                              <div className="flex gap-2 flex-col">
                                <div className="flex bg-gray-100 h-[35px] justify-center items-center px-5 rounded-full text-xl text-gray-800">
                                  <div
                                    onClick={() => dec(pt.quantity, pt._id)}
                                    className="px-3 cursor-pointer"
                                  >
                                    <Minus size={18} />
                                  </div>
                                  <div className="px-3 text-[14px]">
                                    {pt.quantity}
                                  </div>
                                  <div
                                    onClick={() =>
                                      inc(
                                        pt.quantity,
                                        pt.productInfo.stock,
                                        pt._id
                                      )
                                    }
                                    className="px-3 cursor-pointer"
                                  >
                                    <Plus size={18} />
                                  </div>
                                </div>
                                <Button
                                  onClick={() =>
                                    dispatch(delete_card_product(pt._id))
                                  }
                                  className="px-5 bg-red-600 text-white hover:bg-red-500"
                                >
                                  Delete{" "}
                                </Button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}

                    {outofstock_products.length > 0 && (
                      <div className="flex flex-col gap-3">
                        <div className="bg-white border border-gray-100 p-4">
                          <h2 className="text-md text-red-500 font-semibold">
                            Out of stock {outofstock_products.length}
                          </h2>
                        </div>
                        <div className="bg-white border border-gray-100 p-4">
                          {outofstock_products.map((p, index) => (
                            <div key={index} className="w-full flex flex-wrap">
                              <div className="flex sm:w-full gap-2 w-7/12">
                                <div className="flex gap-2 justify-start items-center">
                                  <img
                                    className="w-[80px] h-[80px] nex_img_cover rounded-sm"
                                    src={p.products[0].images[0]}
                                    alt="product"
                                  />
                                  <div className="px-2 text-gray-900">
                                    <h2 className="text-md">
                                      {p.products[0].name}
                                    </h2>
                                    <span className="text-sm">
                                      Brand : {p.products[0].brand}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-between w-5/12 sm:w-full sm:mt-3">
                                <div className="pl-4 sm:pl-0 flex flex-col gap-2">
                                  <h2 className="text-lg text-green-500">
                                    $
                                    {p.products[0].price -
                                      Math.floor(
                                        (p.products[0].price *
                                          p.products[0].discount) /
                                          100
                                      )}
                                  </h2>
                                  <p className="text-gray-900">
                                    {p.products[0].price}
                                  </p>
                                  <p className="text-sm">
                                    -{p.products[0].discount}%
                                  </p>
                                </div>
                                <div className="flex gap-2 flex-col">
                                  <div className="flex bg-gray-100 h-[35px] justify-center items-center px-5 rounded-full text-xl">
                                    <div
                                      onClick={() => dec(p.quantity, p._id)}
                                      className="px-3 cursor-pointer"
                                    >
                                      <Minus size={18} />
                                    </div>
                                    <div className="px-3 text-[14px]">
                                      {p.quantity}
                                    </div>
                                    <div
                                      onClick={() =>
                                        inc(
                                          p.quantity,
                                          p.products[0].stock,
                                          p._id
                                        )
                                      }
                                      className="px-3 cursor-pointer"
                                    >
                                      <Plus size={18} />
                                    </div>
                                  </div>
                                  <Button
                                    onClick={() =>
                                      dispatch(delete_card_product(p._id))
                                    }
                                    className="px-5 py-[3px] bg-red-600 hover:text-white hover:bg-red-500 text-white"
                                  >
                                    Delete
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-[33%] md-lg:w-full">
                <div className="pl-3 md-lg:pl-0 md-lg:mt-5">
                  {card_products.length > 0 && (
                    <div className="bg-white border border-gray-100 shadow-sm p-3 text-gray-900 flex flex-col gap-8">
                      <h2 className="text-xl font-bold flex items-center">
                        Order summary <ScrollText className="ml-2" />
                      </h2>
                      <div className="flex justify-between items-center">
                        <span>{buy_product_item} Items</span>
                        <span className="text-green-500"> {formatCurrency(price,currencyCode,
  exchangeLoaded)}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span>Total</span>
                        <span className="text-lg text-gray-900">{formatCurrency(price, currencyCode,
  exchangeLoaded)}</span>
                      </div>
                      <Button
                        onClick={redirect}
                        className="px-5 py-[6px] rounded-full"
                      >
                        Proceed to checkout
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-4">
              <p>You have no items in your cart.</p>
              <Link to="/stores">
                <Button>Shop Now</Button>
              </Link>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Card;
